import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbInputModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbSpinnerModule,
  NbDatepickerModule,
  NbFormFieldModule,
  NbDialogModule,
} from '@nebular/theme';

import { AuthModule } from '../../@auth/auth.module';
import { ComponentsModule } from 'app/@components/components.module';

import { PublicFoodsRoutingModule } from './public-foods-routing.module';
import { PublicFoodsComponent } from './public-foods.component';
import { PublicFoodsListComponent } from './public-foods-list/public-foods-list.component';
import { CustomFoodComponent, CustomFoodQuickAddComponent } from './custom-food/custom-food.component';
import { GraphModule } from './meal-metrics-graph/meal-metrics-graph.module';

const NB_MODULES = [
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbFormFieldModule,
  NbInputModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbSpinnerModule,
  NbDatepickerModule,
  NbDialogModule,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule,
    ComponentsModule,
    Ng2SmartTableModule,
    ...NB_MODULES,
    PublicFoodsRoutingModule,
    GraphModule,
  ],
  declarations: [
    PublicFoodsComponent,
    PublicFoodsListComponent,
    CustomFoodComponent,
    CustomFoodQuickAddComponent
  ],
  exports: [CustomFoodComponent],
  entryComponents: [],
  providers: [],
})
export class PublicFoodsModule {}
